import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShield2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shield-2, safety, privacy"} maskId="square-filled-radius-0-stroke-1-IconShield2"><path fillRule="evenodd" clipRule="evenodd" d="M21 5.16511L12 1.45923L3 5.16511V13C3 17.9705 7.02944 22 12 22C16.9706 22 21 17.9705 21 13V5.16511Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShield2;
